import * as React from 'react';
import { FormattedMessageHelper } from '../../shared/helpers/internationalization';
import './Footer.scss';

export function Footer() {
  return (
    <footer className="cookie-settings-footer">
      <a className="cookie-settings-footer__link cky-banner-element">
        <FormattedMessageHelper id="header.rightMenu.cookieSettings" />
      </a>
    </footer>
  );
}
